/** Зеркало server/utils/dataExportSettings.js */

export const DATA_EXPORT_SETTING_KEY = 'data_export';

export const EXPORT_ITEM_KEYS = [
  'dismissed_logs',
  'managers_roster',
  'mrp_stats',
  'junior_stats',
  'reprimands',
  'activity_logs',
];

export const EXPORT_ITEM_LABELS = {
  dismissed_logs: 'Логи снятых модераторов',
  managers_roster: 'Список менеджеров',
  mrp_stats: 'Статистика менеджеров 5RP',
  junior_stats: 'Статистика Junior',
  reprimands: 'Выговоры',
  activity_logs: 'Логи активности сайта',
};

export const EXPORT_ITEM_DESCRIPTIONS = {
  dismissed_logs: 'Все записи из раздела «Логи снятых»: ник, период, причина, комментарий.',
  managers_roster: 'Активные и удалённые менеджеры: ник, Discord ID, сервер, роли, даты.',
  mrp_stats:
    'За последние 8 недель по дням: Понедельник → список модеров и метрики, Вторник → …',
  junior_stats:
    'За последние 8 недель по дням: Понедельник → список junior и метрики, Вторник → …',
  reprimands: 'Активные и снятые выговоры из таблицы на сайте.',
  activity_logs: 'Последние 500 действий на сайте (кто, что, когда).',
};

export const DEFAULT_ITEMS = {
  dismissed_logs: true,
  managers_roster: false,
  mrp_stats: true,
  junior_stats: false,
  reprimands: false,
  activity_logs: false,
};

export const DEFAULT_DATA_EXPORT = {
  interval_days: 7,
  last_export_at: null,
  next_export_at: null,
  items: { ...DEFAULT_ITEMS },
};

function clampIntervalDays(value) {
  const n = parseInt(value, 10);
  if (!Number.isFinite(n)) return DEFAULT_DATA_EXPORT.interval_days;
  return Math.min(90, Math.max(1, n));
}

function parseIsoOrNull(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

function normalizeItems(raw) {
  const src = raw && typeof raw === 'object' ? raw : {};
  const out = { ...DEFAULT_ITEMS };
  for (const key of EXPORT_ITEM_KEYS) {
    if (Object.prototype.hasOwnProperty.call(src, key)) {
      out[key] = Boolean(src[key]);
    }
  }
  return out;
}

export function normalizeDataExportSettings(raw) {
  const src = raw && typeof raw === 'object' ? raw : {};
  const interval_days = clampIntervalDays(src.interval_days);
  const last_export_at = parseIsoOrNull(src.last_export_at);
  let next_export_at = parseIsoOrNull(src.next_export_at);
  if (
    next_export_at == null &&
    last_export_at &&
    !Object.prototype.hasOwnProperty.call(src, 'next_export_at')
  ) {
    next_export_at = new Date(
      new Date(last_export_at).getTime() + interval_days * 24 * 60 * 60 * 1000,
    ).toISOString();
  }
  return {
    interval_days,
    last_export_at,
    next_export_at,
    items: normalizeItems(src.items),
  };
}
